import { motion } from "framer-motion";

<motion.div
  className="modern-card"
  whileHover={{ y: -5 }}
  transition={{ duration: 0.2 }}
></motion.div>

export default function HotelInfo({ data }) {
  return (
    <div className="modern-card">

      <div className="section-title">Informations</div>

      <div className="d-flex flex-column gap-2">
        <div><strong>Type :</strong> {data.type}</div>
        <div><strong>Adresse :</strong> {data.adress}</div>
        <div><strong>Description :</strong> {data.desc}</div>
      </div>

    </div>
  );
}